var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 81,
    viewBox: "0 0 100 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.9531 5.29688V19.7964C76.9531 20.3487 76.5054 20.7964 75.9531 20.7964H62.8602C62.3079 20.7964 61.8602 21.2441 61.8602 21.7964V34.6501C61.8602 35.2024 61.4124 35.6501 60.8602 35.6501H48.414C47.8617 35.6501 47.414 36.0979 47.414 36.6501V49.0733C47.414 49.6256 46.9663 50.0733 46.414 50.0733H33.9679C33.4156 50.0733 32.9679 50.5211 32.9679 51.0733V63.2813C32.9679 63.8335 32.5202 64.2813 31.9679 64.2813H16.7969",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7188 5.29688H64.6484",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.375 1L66.7969 1",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2969 46.7031H82.2266",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9531 42.4062L84.375 42.4063",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9688 79.9062H45.8984",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.625 75.6094L48.0469 75.6094",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.375 2.75781V8.8125",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4023 5.78516L31.3477 5.78516",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2656 34.9844H25.1953",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9219 30.6875L27.3437 30.6875",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.3828,
    cy: 5.88281,
    r: 1.36719,
    fill: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 98.6328,
    cy: 51.5859,
    r: 1.36719,
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7812 63.1094L76.9049 65.5014L79.2969 66.625L76.9049 67.7486L75.7812 70.1406L74.6576 67.7486L72.2656 66.625L74.6576 65.5014L75.7812 63.1094Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73438 29.125L3.51164 31.0821L5.46875 31.8594L3.51164 32.6366L2.73438 34.5938L1.95711 32.6366L0 31.8594L1.95711 31.0821L2.73438 29.125Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.7afc63a9bdc2441bed7a1a8f8bf29ac9.svg";
export { ForwardRef as ReactComponent };